export default __webpack_public_path__ + "static/01-buyer-search-fabrics-1cbe996d8f09d329c0c5a19b4d4e81b1.png";